<template>
	<div
		class="trade-ins-container"
		:style="$grid('1')"
	>
		<TabMenu
			v-if="tabs && tabs.length > 0"
			ref="tabMenu"
			:tabs="tabs"
			:initialTab="lastTab"
		>
			<template
				#[`tab-head-${tab}`]
				v-for="(tab, index) in tabs"
				:key="index"
			>
				<div :invalidTab="v$.fimenu.tradeIns[index].$invalid">
					<span>{{ tab }}</span>

					<button
						class="close-button button-span"
						@click="confirmDeletion(index)"
					>
						<i class="far fa-times-circle" />
					</button>
				</div>
			</template>
			<template
				#[`tab-panel-${tab}`]
				v-for="(tab, index) in tabs"
				:key="index"
			>
				<fieldset :disabled="populatingVehicleDetails">
					<div :style="$grid('1')">
						<PanelTradeInVehicle
							:fimenu="fimenu"
							:panelObject="{ title: fimenu.tradeIns[index].getTitle() }"
							:vehicleInfo="fimenu.tradeIns[index]"
							:tradeIndex="index"
						>
						</PanelTradeInVehicle>
					</div>
				</fieldset>
			</template>
		</TabMenu>

		<fieldset
			class="radio-button-inline"
			:invalid="fimenu.hasOtherTradeIns == null"
		>
			<span> Is there {{ tabs && tabs.length > 0 ? 'another' : 'a' }} trade in? </span>

			<InputRadio
				label="Yes"
				:valueMatch="null"
				v-model="fimenu.hasOtherTradeIns"
				:isButton="true"
				@click="addTradeIn"
				:disabled="isDisabled"
			/>
			<InputRadio
				label="No"
				:valueMatch="false"
				v-model="fimenu.hasOtherTradeIns"
				:isButton="true"
				:disabled="isDisabled"
			/>
		</fieldset>
	</div>
</template>
<script lang="ts">
	export interface IPanelTradeInProps {
		fimenu: FIMenu;
		isDisabled: boolean;
	}
</script>
<script setup lang="ts">
	//import PanelVehicleRecallInfo from '@core/components/PanelVehicleRecallInfo.vue'
	import FIMenu from '@core/classes/FIMenu';
	import FIMenuCustomer from '@core/classes/FIMenuCustomer';
	import FIMenuTradeIn from '@core/classes/FIMenuTradeIn';

	import InputRadio from '@core/components/InputRadio.vue';
	import modalInfo from '@core/modals/modalInfo.vue';
	import PanelTradeInVehicle from '@/components/PanelTradeInVehicle.vue';
	import TabMenu from '@/components/TabMenu.vue';

	import $modal from '@core/services/modal';
	import { Emitter } from 'mitt';
	import { useVuelidate } from '@vuelidate/core';
	import util from '@core/services/util';

	import { computed, defineProps, inject, ref, onBeforeMount, onBeforeUnmount } from 'vue';

	const EventBus = inject<Emitter<any>>('EventBus', null);

	// #region Props
	const { fimenu, isDisabled } = defineProps<IPanelTradeInProps>();
	// #endregion

	// #region Validation
	const validations = computed(() => ({
		fimenu: {
			tradeIns: {
				...fimenu.tradeIns.map(t => t.validation(fimenu)),
			},
		} as any,
	}));
	const v$ = useVuelidate(validations, { fimenu });
	// #endregion

	// #region Lifecycle hooks
	onBeforeMount(() => {
		EventBus.on('populatingVehicleDetails', populatingVehicleDetailsEmitterHandler);
	});

	onBeforeUnmount(() => {
		EventBus.off('populatingVehicleDetails', populatingVehicleDetailsEmitterHandler);
	});
	// #endregion

	const populatingVehicleDetails = ref(false);

	const tabs = computed(() => {
		return fimenu.tradeIns?.map((t, index) => `Trade-In ${index + 1}`);
	});

	const lastTab = computed(() => {
		return tabs.value[tabs.value.length - 1];
	});

	function populatingVehicleDetailsEmitterHandler(newVal: boolean) {
		populatingVehicleDetails.value = newVal;
	}
	function addTradeIn() {
		// When Co-Browsing enabled, block Spectators from adding a trade-in
		if (fimenu.store.storeSettings.isDealCoBrowsingEnabled && fimenu.isSpectator) return;

		if (fimenu.tradeIns.length > 7)
			return util.toastr('Error', 'Exceeded Trade In Amounts', 'The limit is 8 trade ins per deal. Please submit a support ticket for further instance.');

		const newTrade = new FIMenuTradeIn();
		newTrade.ownersList.push('');
		newTrade.customersAsOwnerInfo = false;

		fimenu.tradeIns.push(newTrade);
		fimenu.hasOtherTradeIns = null;
	}
	function confirmDeletion(tradeIndex: any) {
		$modal.open(modalInfo, {
			name: 'modalInfo',
			passedData: {
				info: 'Are you sure you want to delete this Trade-In?',
				acceptText: 'Yes',
				cancelText: 'Cancel',
			},
			backdrop: false,
			postFunction: () => {
				fimenu.tradeIns.splice(tradeIndex, 1);

				fimenu.hasOtherTradeIns = null;
			},
		});
	}
</script>
<style>
	.trade-ins-container {
		margin-top: 10px;
	}
</style>
